import { CheckoutsFilterInput, CheckoutsSortInput } from "checkouts/reducer";
import { GetInquiryCheckoutsConnectionsInquiry } from "core/queries/GetInquiryCheckouts";

export enum ActionType {
  SelectBooking = "SELECT_BOOKING",
  ClearSelectedBooking = "CLEAR_SELECTED_BOOKING",
  SetFilters = "SET_FILTERS",
  SetSortOptions = "SET_SORT_OPTIONS",
}

export interface SelectBookingAction {
  type: ActionType.SelectBooking;
  payload: GetInquiryCheckoutsConnectionsInquiry | null;
}
export const selectBooking = (
  booking: GetInquiryCheckoutsConnectionsInquiry | null,
): SelectBookingAction => ({
  type: ActionType.SelectBooking,
  payload: booking,
});

export interface ClearSelectedBookingAction {
  type: ActionType.ClearSelectedBooking;
}
export const clearSelectedBooking = (): ClearSelectedBookingAction => ({
  type: ActionType.ClearSelectedBooking,
});

export interface SetFiltersAction {
  type: ActionType.SetFilters;
  payload: CheckoutsFilterInput;
}

export const setFilters = (
  filters: CheckoutsFilterInput,
): SetFiltersAction => ({
  type: ActionType.SetFilters,
  payload: filters,
});
export interface SetSortOptionsAction {
  type: ActionType.SetSortOptions;
  payload: CheckoutsSortInput[];
}

export const setSortOptions = (
  options: CheckoutsSortInput[],
): SetSortOptionsAction => ({
  type: ActionType.SetSortOptions,
  payload: options,
});
